export type SupabasePublicApiKeySource = 'publishable' | 'anon';

const readTrimmedPublicEnv = (value: string | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed || null;
};

export const normalizeSupabaseUrl = (value: string | undefined): string | null => (
  readTrimmedPublicEnv(value)
);

export const resolveSupabasePublicApiKey = (
  publishableKeyValue: string | undefined,
  anonKeyValue: string | undefined
): {
  key: string | null;
  source: SupabasePublicApiKeySource | null;
} => {
  const publishableKey = readTrimmedPublicEnv(publishableKeyValue);
  if (publishableKey) {
    return { key: publishableKey, source: 'publishable' };
  }

  const anonKey = readTrimmedPublicEnv(anonKeyValue);
  if (anonKey) {
    return { key: anonKey, source: 'anon' };
  }

  return { key: null, source: null };
};

export const getSupabaseUrl = (): string | null => (
  // Expo so injeta EXPO_PUBLIC_* quando a referencia usa dot notation estatica.
  normalizeSupabaseUrl(process.env.EXPO_PUBLIC_SUPABASE_URL)
);

export const getSupabasePublicApiKey = (): {
  key: string | null;
  source: SupabasePublicApiKeySource | null;
} => resolveSupabasePublicApiKey(
  process.env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
  process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY
);
